import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { HelpLinkButton } from '../modal/helpModal/helpModal';

const DCAInstructionsAmazonAdvertisingDSP: JSX.Element = (
  <Container
    className="mb-3"
    data-testid="dca-instructions-amazon-aa-dsp"
  >
    <Row>
      <h3
        className="text-capitalize mt-2"
      >
        How to add an Amazon Advertising Demand Side Platform account
      </h3>
    </Row>
    <Row className="mb-3 p-3 pad-child-list-elements bg-warning">
      <p>
        Amazon Advertising Demand Side Platform Accounts can only be added by Insights Team Members.
      </p>
      <p>
        It is recommended that this be run from Marshall Management (Internal) - Org 60.
      </p>
    </Row>
    <Row className="ps-3 pad-child-list-elements">
      <ol>
        <li>
          <b>
            Sign into Amazon Advertising (AA):
          </b>
          <ul>
            <li>
              Use a separate browser tab to sign in as&nbsp;
              <b>
                amazon-advertisingapi@marshassoc.com
              </b>
              .
            </li>
            <li>
              Ensure the active selected account is&nbsp;
              <b>
                Marshall Associates
              </b>
              .
            </li>
            <li>
              Verify the &quot;account&quot; displayed in the top right navigation bar in AA.
              It should read&nbsp;
              <b>
                All accounts
              </b>
              .
            </li>
            <li>
              Ensure you see the requested DSP account to be added is listed
              in the account manager overview.&nbsp;
              <i>
                (e.g. https://advertising.amazon.com/am/oveview)
              </i>
            </li>
          </ul>
        </li>
        <li>
          <b>
            Authorize the Account:
          </b>
          <ul>
            <li>
              Click the&nbsp;
              <span className="badge bg-black">
                Add
              </span>
              &nbsp;button below.
            </li>
            <li>
              You will be redirected to Amazon Advertising for authorization.
            </li>
            <li>
              Verify that &quot;All accounts&quot; is displayed in the top navigation bar in AA.
            </li>
            <li>
              If not, close the tab, reopen Insights, and start again.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Grant Access:
          </b>
          <ul>
            <li>
              Select the checkbox to provide Marshall Insights access.
            </li>
            <li>
              Click &quot;Allow&quot;.
            </li>
            <li>
              If you are unable to grant access, ensure you have the necessary permissions
              in AA to authorize data collection.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Complete the Process:
          </b>
          <ul>
            <li>
              You will be redirected back to Marshall Insights.
            </li>
            <li>
              A success message will indicate the account has been added.
            </li>
          </ul>
        </li>
      </ol>
    </Row>
    <Row>
      <b>
        Troubleshooting:
      </b>
      <p>
        If you encounter any issues or have questions, contact
        <HelpLinkButton />
        .
      </p>
    </Row>
  </Container>
);

export default DCAInstructionsAmazonAdvertisingDSP;
